/**
 * Created by staffanrantzow on 24/03/16.
 */

/* @flow */
import React from 'react';
import Translate from 'react-translate-component';

export class MissingView extends React.Component {
  render () {
    return (
      <div className='missing-page container page'>
        <div className='col-sm-6 col-sm-push-3'>
          <h1>404</h1>
          <p><Translate content='MISSING_PAGE' /></p>
        </div>
      </div>
    );
  }
}
export default MissingView;



/** WEBPACK FOOTER **
 ** ./src/views/missing-view/missing-view.js
 **/